<div
  class="option-wrapper"
  (click)="optionClicked.emit(event())"
  role="button"
  [tabindex]="event()">
  <shared-info-and-icon [icon]="icon()" [infoText]="option()" class="option" />
</div>
